var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative flex overflow-y-hidden px-5 px-3-ns",style:(_vm.isMobile ? {
  height: '340px'
} : {
  height: (_vm.height + "px")
})},[_c('div',{staticClass:"iphone-x"},[_c('i',[_vm._v("Speaker")]),_c('b',[_vm._v("Camera")]),(!_vm.isMobile)?_c('video',{staticClass:"w-100 device-content",staticStyle:{"border-radius":"40px"},attrs:{"muted":"muted","autoplay":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"https://picturepan2.github.io/devices.css/src/video/bg-01.mp4","type":"video/mp4"}})]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }